module.exports = __webpack_public_path__ + "img/55874c7f1c7bbdee071cd6b3207e0ba.6261fe78.jpg";